import { render, staticRenderFns } from "./CustomerReportTab.vue?vue&type=template&id=447f9b23"
import script from "./CustomerReportTab.vue?vue&type=script&lang=js"
export * from "./CustomerReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports